<template>
  <div style="user-select: none;">
    <h1 class="title-gradient">
      {{ logo?.toUpperCase() || "Meeting Engine (Beta)"}}
    </h1>
  </div>
</template>

<script>
  export default {
    logo: "LogoComponent",
    props: {
      logo: {
        type: String,
        required: false,
      }
    },
    created(){
      console.log('Logo Component: ', this.logo);
    }
  }
</script>

<style scoped>
.title-gradient {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(90deg, #17a2b8, #ff9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.beta {
  font-weight: normal;
}
</style>